import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "@/contexts/AuthContext";

export function ClinicAccountRoute({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex min-h-screen items-center justify-center">Carregando...</div>;
  const isSuperAdmin = user?.role === "superadmin" || user?.email === "suporte@cloudservidores.com";
  return isSuperAdmin ? <Navigate to="/superadmin" replace /> : <>{children}</>;
}
